<template>

  <div>
    <div v-if="loading">
      <b-icon
        pack="fa"
        icon="spinner"
        custom-class="fa-spin">
      </b-icon>
    </div>
    <div v-else>
      <div
        class="mb-6"
        style="font-size: 1.3rem; font-weight: 700; color: var(--v-mainColor3-base);"
      >
        History <span style="font-size: 1.3rem; color: var(--v-darkGrayColor-base);">({{ reports?.length || 0 }})</span>
      </div>

      <div class="table-box">
        <div class="table-head">
          <v-text-field
            class="search-field"
            outlined dense hide-details
            label="Search"
            prepend-inner-icon="search"
            style="max-width: 300px;"
            v-model="search"
          />
        </div>
  
        <b-table
          v-if="reports?.length"
          :data="filteredReports"
          :paginated="filteredReports.length > 10"
          sortable
          :total="filteredReports.length"
          :per-page="10"
        >
  
          <template slot-scope="props">

            <b-table-column field="topics" label="Topics">
              <router-link
                 style="color: var(--v-mainColor3-base);"
                :to="`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy/${siloTypeToRoutePath(props.row.researchType)}${props.row.id}`"
              >
                <div class="d-flex gap10 mb-2">
                  <span v-if="props.row.topics.length >= 5">
                    <template v-if="props.row.name">{{ props.row.name }}</template>
                    <template v-else>{{ props.row.topics.map(topics => topics.topic || topics.competitor).slice(0, 4).join(', ') }}..</template>

                    <v-tooltip top color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs" v-on="on"
                          
                        >(<span style="color: var(--v-darkGrayColor-base); text-decoration: underline; text-decoration-style: dotted;">{{ props.row.topics.length }} topics</span>)</span>
                      </template>
                      <div style="max-width: 350px;">{{ props.row.topics.map(topics => topics.topic || topics.competitor).join(', ') }}</div>
                    </v-tooltip>
                    
                  </span>
                  <span v-else>
                    {{ props.row.name ? props.row.name : props.row.topics.map(topics => topics.topic || topics.competitor).join(', ') }}
                  </span>
                </div>
              </router-link>

              <div class="d-flex gap10 align-center">
                <span style="color: var(--v-gray50Color-base);"><span v-if="locationCodeToISO(props.row.locationCode) !== 'Unknown Location'" :class="`fi fi-${locationCodeToISO(props.row.locationCode).toLowerCase()}`"></span> {{ locationCodeToISO(props.row.locationCode) }}</span>
                <span style="color: var(--v-grayColor-base);">•</span>
                <span style="color: var(--v-gray50Color-base);">Report ID: #{{ props.row.id }}</span>
                <v-progress-linear
                  v-if="!!getInProgressAsyncTaskFromReport(props.row)"
                  class="ml-4"
                  style="width: 60px;"
                  rounded height="3"
                  color="profileAnchorColor"
                  :value="getInProgressAsyncTaskFromReport(props.row).task_status.value || 0">
                </v-progress-linear>
              </div>
              
              
            </b-table-column>

            <b-table-column field="researchType" label="Type" sortable width="150" style="vertical-align: middle;">
              <div class="d-flex align-center gap5">
                <i class="material-icons-outlined" style="color:var(--v-gray40Color-base);">{{ siloTypeToIcon(props.row.researchType) }}</i>
                {{ siloTypeToLabel(props.row.researchType) }}
              </div>
            </b-table-column>
            
            <b-table-column field="createdAt" label="Date created" sortable width="150" style="vertical-align: middle;">
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="color: var(--v-mainColor3-base);">{{ showElaspedTime(props.row.createdAt) }}</span>
                </template>
                <div>{{ formatDate(props.row.createdAt) }}</div>
              </v-tooltip>
              
            </b-table-column>

            <b-table-column label="" width="150" style="vertical-align: middle;">
              <div class="f-flex gap10 align-center">
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="gray40Color"
                      v-bind="attrs" v-on="on"
                      @click="onShowModal(`Rename ${props.row.name}`, 1, props.row.name, props.row.id)"
                    >
                      <i class="material-icons-outlined" style="font-size: 20px;">edit</i>
                    </v-btn>
                  </template>
                  <div>Rename</div>
                </v-tooltip>

                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="gray40Color"
                      :title="props.row.isFavorite ? 'Remove from favorites' : 'Add to favorites'"
                      v-bind="attrs" v-on="on"
                      @click="updateReportItem(props.row.id, 'isFavorite', !props.row.isFavorite, () => {})"
                    >
                      <i v-if="props.row.isFavorite" class="material-icons-outlined" style="font-size: 20px; color: var(--v-profileAnchorColor-base);">star</i>
                      <i v-else class="material-icons-outlined" style="font-size: 20px;">star_border</i>
                    </v-btn>
                  </template>
                  <div>{{ props.row.isFavorite ? 'Remove from favorites' : 'Add to favorites' }}</div>
                </v-tooltip>

                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="gray40Color"
                      :disabled="!!getInProgressAsyncTaskFromReport(props.row)"
                      v-bind="attrs" v-on="on"
                      @click="onShowModal(`Delete ${props.row.name}`, 2, '', props.row.id)"
                    >
                      <i class="material-icons-outlined" style="font-size: 20px;">delete</i>
                    </v-btn>
                  </template>
                  <div>Delete</div>
                </v-tooltip>

              </div>
            </b-table-column>

          </template>
        </b-table>

        <div v-else class="d-flex flex-column align-center" style="border-top: 1px solid var(--v-gray12Color-base); padding: 100px 20px;">

          <img src="/static/icon_empty_state.svg" class="pb-6" />

          <span style="font-weight: 700; font-size: 1rem;">You don’t have any keywords yet</span>
        </div>
      </div>

      <keyword-research-modal
        :showModal="showModal"
        :modalTitle="modalTitle"
        :modalType="modalType"
        :reportTitle="modalFieldValue"
        @cancel="onCancelModal"
        @close="onCloseModal"
        @update-title="modalFieldValue = $event"
      />
    </div>
  </div>

</template>

<script>
import moment from 'moment';

import KeywordResearchModal from '@/common/KeywordResearchModal.vue';
import dataForSeoLocations from '@/consts/dataforseo_locations.json';
import rockyKeywordScreenMixin, {
  KEYWORD_SCREENS,
  MAX_LIST_ITEMS,
  summarize,
  short as rockyShort,
} from '../../rockyKeywordScreen.js';

import "/node_modules/flag-icons/css/flag-icons.min.css";

export default {
  mixins: [rockyKeywordScreenMixin],
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    KeywordResearchModal,
  },
  data () {
    return {
      loading: true,
      reports: [],
      search: '',

      showModal: false,
      modalFieldValue: '',
      modalTitle: '',
      modalType: 1,
      modalActiveReportId: 0,
    }
  },
  computed: {
    filteredReports() {
      if (!this.search) {
        return this.reports
      }

      const search = this.search ? this.search.toLowerCase() : ''

      return this.reports.filter((report) => {
        return String(report.topics.map(topics => topics.topic)).includes(search) || String(report.id).includes(search) || String(report.name).includes(search)
      })
    },
    asyncTasks() {
      return this.$store.state.asyncTasks
    },
  },
  watch: {
    '$store.state.triggerRockyRefresh': function () {
      this.handleRockyRefresh();
    },
    reports () { this.emitRockyKeywordScreen() },
    search () { this.emitRockyKeywordScreenDebounced() },
  },
  methods: {
    handleRockyRefresh() {
      this.loadReports({ silent: true });
    },
    buildRockyScreenData() {
      return {
        screen: KEYWORD_SCREENS.STRATEGY_LIST,
        status: this.loading ? 'loading' : (this.reports.length ? 'ready' : 'empty'),
        loading: this.loading,
        recordIds: {},
        data: {
          reports: summarize(this.filteredReports, (r) => ({
            siloResearchId: String(r.id),
            name: rockyShort(r.name),
            researchType: r.researchType,
            topics: (r.topics || []).slice(0, 10).map(t => rockyShort(t.topic || t.competitor)),
            topicCount: (r.topics || []).length,
            locationCode: r.locationCode != null ? r.locationCode : null,
            createdAt: r.createdAt || null,
            favorite: !!r.isFavorite,
            inProgress: !!this.getInProgressAsyncTaskFromReport(r),
          }), MAX_LIST_ITEMS),
          viewState: { search: rockyShort(this.search) },
        },
      }
    },
    loadReports( {silent = false} ) {
      if (!silent) {
        this.loading = true
      }

      return this.$store.dispatch('siloResearchList', {
        campaignId: this.campaign.id
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.reports = response.data.researches
        }
      }) .finally(() => {
        if (!silent) {
          this.loading = false
        }
      })
    },
    getInProgressAsyncTaskFromReport(report) {
      return this.asyncTasks.filter(task => task.type.startsWith('SiloResearch.') && task.record_id === report.id && Boolean(task.is_pending_or_in_progress))?.[0]
    },
    updateReportItem(reportId, key, value, onComplete = () => {}) {
      this.$store.commit('showLoading')
      this.$store.dispatch('siloResearchSinglePatch', {
        id: reportId,
        [key]: value
      }).then(() => {
        return this.loadReports({silent: true})
      }).catch((e) => {
        console.log('Error starring/unstarring keyword wizard report', e)
        // do nothing
      }).finally(() => {
        this.$store.commit('hideLoading')
        onComplete()
      })
    },
    onShowModal(title, type, currentTitle = '', reportId = 0) {
      this.modalFieldValue = currentTitle;
      this.showModal = true;
      this.modalTitle = title;
      this.modalType = type;
      this.modalActiveReportId = reportId;
    },
    onCancelModal() {
      this.showModal = false;
      this.modalTitle = '';
      this.modalType = 1;
      this.modalFieldValue = '';
      this.modalActiveReportId = 0;
    },
    onCloseModal() {
      if (this.modalType == 1) {
        this.updateReportItem(
          this.modalActiveReportId,
          'name',
          this.modalFieldValue,
          () => {
            this.onCancelModal()
          }
        );
      } else {
        this.deleteReport(this.modalActiveReportId, () => {
          this.onCancelModal()
        });
      }
    },
    deleteReport(reportId, onComplete = () => {}) {
      this.$store.commit('showLoading')
      this.$store.dispatch('siloResearchSingleDelete', {
        id: reportId,
      }).then(() => {
        return this.loadReports({silent: true})
      }).catch((e) => {
        console.log('Error deleting keyword wizard report', e)
        // do nothing
      }).finally(() => {
        this.$store.commit('hideLoading')
        onComplete()
      })
    },
    showElaspedTime(time) {
      return moment.utc(time).fromNow();
    },
    formatDate(date) {
        return new Date(date).toLocaleDateString();
    },
    locationCodeToISO(code) {
      return dataForSeoLocations.locations.filter(location => location.location_code == code)?.[0]?.country_iso_code || 'Unknown Location'
    },
    siloTypeToLabel(value) {
      if (value === 'one-click-silo') {
        return '1-click-silo'
      } else if (value === 'custom-silo') {
        return 'Custom silo'
      }
      return value
    },
    siloTypeToIcon(value) {
      if (value === 'one-click-silo') {
        return 'bolt'
      } else if (value === 'custom-silo') {
        return 'build'
      }
      return null
    },
    siloTypeToRoutePath(value) {
      if (value === 'one-click-silo') {
        return 'one-click-silo/'
      } else if (value === 'custom-silo') {
        return 'custom-silo/'
      }
      return ''
    }
  },
  mounted () {
    this.emitRockyKeywordScreen()
    this.loadReports({}).then(() => this.emitRockyKeywordScreen())
  }
}
</script>

<style lang="scss" scoped>
@import "./../styles.scss";

.table-box {
  background-color: var(--v-whiteColor-base);
  border: 1px solid var(--v-gray12Color-base);
  border-radius: 4px;
  
  .table-head {
    padding: 12px 20px;

    .search-field {
      ::v-deep {
        .v-icon {
          color: var(--v-gray12Color-base);
        }
        fieldset {
          border-color: var(--v-gray12Color-base);
        }
      }
    }
  }

  ::v-deep {
    .b-table tbody tr td, .b-table th > * {
      color: var(--v-mainColor3-base);
    }

    .b-table .pagination .pagination-list .pagination-link.is-current {
      background-color: var(--v-gray12Color-base);
    }
  }
  

  .b-table {
    border-top: 1px solid var(--v-gray12Color-base);
    ::v-deep {
      .table {
        border: none;
        td, th {
          border-color: var(--v-gray12Color-base);
          border-width: 0 0 1px;
        }

        th {
          padding: 12px 20px;
        }

        td {
          padding: 18px 20px;
        }
      }
    }
  }
}
</style>